import { updateDynamicData, DynamicDataTypeEnum } from '@kaltura-ott/tvpil';
import { lastValueFrom } from 'rxjs';

/**
 *
 * @param value
 */
export const ageThresholdValueUpdate = async (value: string) => {
  return lastValueFrom(updateDynamicData({ key: DynamicDataTypeEnum.ageThreshold, value }));
};
